/* eslint-disable jira/integration/test-id-by-folder-structure */
import React from 'react';
import { Stack } from '@atlaskit/primitives/compiled/stack';
import { Inline } from '@atlaskit/primitives/compiled/inline';
import Skeleton from '@atlaskit/skeleton';
import { token } from '@atlaskit/tokens';

export const TemplatesListLoadingView = (): React.JSX.Element => (
	<Stack
		space="space.200"
		testId="playbooks-list-screen.ui.playbook-templates.edge-cases.templates-list-loading-view"
	>
		<Skeleton height={20} width={220} borderRadius={token('radius.small')} isShimmering />
		<Inline space="space.200">
			<Skeleton height={282} width={272} borderRadius={token('radius.large')} isShimmering />
			<Skeleton height={282} width={272} borderRadius={token('radius.large')} isShimmering />
		</Inline>
	</Stack>
);
